import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { css } from 'emotion'
import * as React from 'react'
const styles = require('./styles')

const annualConsumerExpenditureSurvey = (
  <ThemeConsumer>
    {({ colorPrimary }) => (
      <a
        className={classnames(css(`color: ${colorPrimary};`))}
        href="https://www.bls.gov/cex/tables.htm"
        target="_blank"
      >
        annual consumer expenditure survey
      </a>
    )}
  </ThemeConsumer>
)

export const spendingProfileDisclosure = (
  <div className={classnames(styles.column)}>
    <span>
      Your average monthly spend is the total of your spending allocations excluding housing transportation, and
      healthcare.
    </span>
    <br />
    <span>To calculate the initial monthly allocations we:</span>
    <ul>
      <li>Calculated your net income based on your reported gross income and income bracket</li>
      <li>
        Calculated expenditures per category based on national U.S. average percentage spends reported in the{' '}
        {annualConsumerExpenditureSurvey}
      </li>
    </ul>
    <span>
      Please update the spending amount categories to accurately reflect your monthly expenses.Your monthly expenses
      should only include transactions you can make with a credit card. This information is used to calculate the
      potential rewards value of each card based on your unique spending habits.
    </span>
  </div>
)

export const offerFlagTooltipContent = (
  <div className={classnames(styles.column)}>
    <p>
      Matched for you means you have a better chance of being approved based on a soft pull of your credit profile. The
      soft pull has no impact on your credit score. Please note: you are not guaranteed approval. If you complete an
      application with the issuer, this will result in a hard inquiry on your credit report and may impact your credit
      score.
    </p>
  </div>
)
